"use client";

import { useEffect } from "react";

export function InAppFontFix() {
  useEffect(() => {
    const ua = navigator.userAgent;
    if (/FBAN|FBAV|Instagram|Line\/|Twitter|MicroMessenger/i.test(ua)) {
      document.documentElement.style.fontSize = "14.5px";
    }
  }, []);
  return null;
}
